import { useEffect, useRef, type ReactNode } from 'react';

// Texto de una sola línea: si no cabe en su contenedor, se recorta y se desliza solo de derecha a
// izquierda para poder leerlo completo (ver .marquee-active en motion.css).
export function MarqueeText({ children, className }: { children: ReactNode; className?: string }) {
  const box = useRef<HTMLSpanElement>(null);
  const text = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const clip = box.current;
    const inner = text.current;
    if (!clip || !inner) return;
    const measure = () => {
      const overflow = Math.ceil(inner.scrollWidth - clip.clientWidth);
      if (overflow > 1) {
        clip.style.setProperty('--marquee-shift', `${-overflow}px`);
        clip.style.setProperty('--marquee-time', `${(2.5 + overflow / 25).toFixed(1)}s`);
        clip.classList.add('marquee-active');
      } else {
        clip.classList.remove('marquee-active');
      }
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(clip);
    return () => observer.disconnect();
  }, [children]);

  return (
    <span ref={box} className={`marquee${className ? ` ${className}` : ''}`}>
      <span ref={text} className="marquee-text">
        {children}
      </span>
    </span>
  );
}
